/*
Copyright (c) 2021
*/

import constants from '../../constants';

const { REQUEST_SENDINVITATION,SENDINVITATION_RECEIVED } = constants.SendInviteConstant;

export default {
    REQUEST_SENDINVITATION,
    SENDINVITATION_RECEIVED,

  requestSendInvite: payload => ({
    type: REQUEST_SENDINVITATION,
    payload
  }),
  sendInviteReceived: () => ({
    type: SENDINVITATION_RECEIVED
  }),
};
